(() => {
  document.querySelectorAll('[data-lp-header]').forEach((header) => {
    const openButton = header.querySelector('[data-lp-menu-open]');
    const closeButton = header.querySelector('[data-lp-menu-close]');
    const panel = header.querySelector('[data-lp-menu-panel]');
    const shopMenu = header.querySelector('[data-lp-shop-menu]');

    if (shopMenu) {
      const shopToggle = shopMenu.querySelector('summary');
      const closeShopMenu = (returnFocus = false) => {
        if (!shopMenu.open) return;
        shopMenu.open = false;
        if (returnFocus) shopToggle.focus();
      };
      document.addEventListener('click', (event) => {
        if (!shopMenu.contains(event.target)) closeShopMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && shopMenu.open) {
          event.preventDefault();
          closeShopMenu(true);
        }
      });
      shopMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeShopMenu()));
    }

    if (!openButton || !closeButton || !panel) return;
    let returnFocus = null;
    let isolatedElements = [];
    const focusableSelector = 'a[href], button:not([disabled])';
    const restoreBackground = () => {
      isolatedElements.forEach(({ element, inert, ariaHidden }) => {
        element.inert = inert;
        if (ariaHidden === null) element.removeAttribute('aria-hidden');
        else element.setAttribute('aria-hidden', ariaHidden);
      });
      isolatedElements = [];
    };
    const isolateBackground = () => {
      const elements = [];
      let branch = panel;
      while (branch.parentElement) {
        [...branch.parentElement.children].forEach((element) => {
          if (element === branch || !(element instanceof HTMLElement) || elements.includes(element)) return;
          elements.push(element);
        });
        branch = branch.parentElement;
        if (branch === document.body) break;
      }
      isolatedElements = elements.map((element) => ({
        element,
        inert: element.inert,
        ariaHidden: element.getAttribute('aria-hidden'),
      }));
      isolatedElements.forEach(({ element }) => {
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      });
    };
    const closeMenu = () => {
      panel.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lp-menu-open');
      restoreBackground();
      if (returnFocus) returnFocus.focus();
    };
    const openMenu = () => {
      returnFocus = document.activeElement;
      isolateBackground();
      panel.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lp-menu-open');
      closeButton.focus();
    };
    openButton.addEventListener('click', openMenu); closeButton.addEventListener('click', closeMenu);
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { closeMenu(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll(focusableSelector)]; const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });
})();
